import OwLabel from "@components/shared/OwLabel/OwLabel";
import UserContext from "@contexts/UserContext";
import EndpointsEnum from "@models/EndpointsEnum";
import IConnection_Token from "@models/IConnection_Token";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import IConnection_TokenUI from "@models/IConnection_TokenUI";
import { Dropdown } from "react-bootstrap";
import SupplierContext from "@contexts/SupplierContext";
import { useNavigate } from "react-router-dom";
import { SocketContext } from "@contexts/SocketContext";
import IGetVendorCsvEntryDTO from "@models/DTO/IGetVendorCsvEntryDTO";
import IOnGetVendorCsvEntryDTO from "@models/DTO/IOnGetVendorCsvEntryDTO";

type Props = {
    supplierVendorToken?: IConnection_TokenUI;
    toggleDockFn: (supplierVendorToken: IConnection_TokenUI) => void;
    editWarehouseAccessFn: (supplierVendorToken: IConnection_TokenUI) => void;
    rowIndex: number;
    toggleConfirmDeleteFn: (data: IConnection_TokenUI, index: number, rowRef: any) => void;
    viewContacts: (supplierVendorToken: IConnection_TokenUI, index: number) => void;
};

export const AccountActionsDropdown = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;

    const navigate = useNavigate();

    const [csvOrderEntryDownload, setCsvOrderEntryDownload] = useState<any>(null);

    useEffect(() => {
        socket.on(EndpointsEnum.VendorsOnGetVendorCsvEntry, onGetVendorCsvEntry);

        return () => {
            socket.off(EndpointsEnum.VendorsOnGetVendorCsvEntry, onGetVendorCsvEntry);
        };
    }, []);

    const downloadCSVOrderEntry = (supplierVendorToken: IConnection_Token) => {
        if (!userModel || !supplierVendorToken.Vendor) {
            return null;
        }

        const payload: IGetVendorCsvEntryDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            vendorGuid: supplierVendorToken.Vendor.guid,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.VendorsGetVendorCsvEntry, payload);
    };

    const onGetVendorCsvEntry = (data: IOnGetVendorCsvEntryDTO) => {
        if (data && props.supplierVendorToken) {
            if (props.supplierVendorToken.Vendor?.guid === data.vendorGuid) {
                const blob = new Blob([data.csvData], { type: "text/csv" });
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);

                const fileName = data.filename;

                link.download = fileName;
                link.click();
            }
        }
    };

    const editVendorAddresses = (supplierVendorToken: IConnection_TokenUI) => {
        // route to the vendor address screen
        let vendorName = "vendors";

        if (supplierModel.vendor_name_override) {
            vendorName = `${supplierModel.vendor_name_override}s`;
        }

        navigate(`/${vendorName}/${supplierVendorToken.Vendor!.guid}/addresses`);
    };

    if (!props.supplierVendorToken) {
        return null;
    }

    return <div className={"AccountActionsDropdown ms-2"}>
        <Dropdown data-bs-theme="dark">
            <Dropdown.Toggle size="sm" variant="primary"><OwLabel title="actions" className="pointer"/></Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item onClick={(e: any) => {
                        editVendorAddresses(props.supplierVendorToken!);
                    }}><OwLabel title="edit_addresses" className="pointer"/>
                </Dropdown.Item>

                {
                    userModel.supplierUserToken?.catalog_id? null : 
                    <Dropdown.Item onClick={(e: any) => {
                        props.toggleDockFn(props.supplierVendorToken!);
                    }}>
                        <OwLabel title="edit_price_group_access" className="pointer"/>
                    </Dropdown.Item>
                }

                {supplierModel.has_warehouses ? (
                    <Dropdown.Item onClick={(e: any) => {
                        props.editWarehouseAccessFn(props.supplierVendorToken!);
                    }}>
                        <OwLabel title="edit_warehouse_access" className="pointer"/>
                    </Dropdown.Item>
                ) : null}

                {
                    props.supplierVendorToken && supplierModel.has_contacts ? (
                        <Dropdown.Item onClick={(e: any) => {
                            props.viewContacts(props.supplierVendorToken!, props.rowIndex);
                        }}>
                            <OwLabel title="edit_contacts" className="pointer"/>
                        </Dropdown.Item>
                    ) : null
                }

                {supplierModel.has_csv_order_entry ? (
                    <Dropdown.Item onClick={(e: any) => {
                        downloadCSVOrderEntry(props.supplierVendorToken!);
                    }}>
                        <OwLabel title="download_csv_entry_file" className="pointer"/>
                    </Dropdown.Item>
                ) : null}

                
            </Dropdown.Menu>
        </Dropdown>
    </div>;
};
